import React, {
    Ref,
    forwardRef,
} from 'react'

import {
    tooltip, tooltipWrapper,
} from './styles'
import {TooltipProps} from './types'
import {styled} from 'stitches/config'

const StyledTooltip = styled('div', tooltip)
const StyledTooltipWrapper = styled('div', tooltipWrapper)

interface TooltipViewProps extends TooltipProps {
    coordinates: {x: number, y: number}
    tooltipVisible: boolean
}

const TooltipView = forwardRef((props: TooltipViewProps, ref: Ref<HTMLDivElement>) => {
    const {
        coordinates, children, tooltipVisible, width, singleLine, position,
    } = props

    if (!tooltipVisible || !children) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>
    }

    return (
        <StyledTooltipWrapper>
            <StyledTooltip
                css={{
                    left: coordinates.x,
                    top: coordinates.y,
                    width,
                    ...singleLine && {whiteSpace: 'nowrap'},
                }}
                position={position}
                ref={ref}
            >
                {children}
            </StyledTooltip>
        </StyledTooltipWrapper>
    )
})

TooltipView.displayName = 'TooltipView'


export default TooltipView
